import NavbarTP from "./technoparts/NavbarTopTP";
import CardSell3TP from "./technoparts/CardSell3TP";
import Dettagli from "./technoparts/DettagliManVen";
import CardSell2TP from "./technoparts/CardSell2TP";
import AreaChartTP from "./technoparts/AreaChartTP";
import GraphicDayTP from "./technoparts/GraphicDayTP";
import GraphicWeekTP from "./technoparts/GraphicWeekTP";
import TabsTP from "./technoparts/TabsClientTP";
import TabsTipoCliTpTP from "./technoparts/TabsTipoCliTp";
import BarChartTP from "./technoparts/BarChartTP";
import BarChartIt from "./technoparts/BarChartIt";
import GoogleMap from "./technoparts/GoogleMap";
import FooterMobile from "./technoparts/FooterMobile";

import React, { useState } from "react";

import "../App.css";
import "./technoparts/technoparts-liquid.css";

function Home() {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const apikey = "AIzaSyD16h98hJe26HkkEvzKPbH2WytgT5srggM";

  return (
    <div className="main-container tp-dashboard-shell">
      <NavbarTP />

      <main className="technoparts tp-dashboard-grid">
        {/* RIGA 1 / COLONNA 1 */}
        <section className="tp-cell tp-summary-cell">
          <div className="tp-summary-pair">
            <CardSell3TP />

            <CardSell2TP
              onCardClick={handleShowModal}
            />
          </div>
        </section>

        {/* RIGA 1 / COLONNA 2 */}
        <section className="tp-cell">
          <TabsTP />
        </section>

        {/* RIGA 1 / COLONNA 3 */}
        <section className="tp-cell">
          <TabsTipoCliTpTP />
        </section>

        {/* RIGA 2 */}
        <section className="tp-cell">
          <GraphicDayTP />
        </section>

        <section className="tp-cell">
          <GraphicWeekTP />
        </section>

        <section className="tp-cell">
          <GoogleMap apiKey={apikey} />
        </section>

        {/* RIGA 3 */}
        <section className="tp-cell">
          <AreaChartTP />
        </section>

        <section className="tp-cell">
          <BarChartTP />
        </section>

        <section className="tp-cell">
          <BarChartIt />
        </section>

        <FooterMobile />
      </main>

      {/* SOLO MOBILE - DOPO L'ULTIMO WIDGET */}
      

      {/* MODALE */}
      <Dettagli
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
    </div>
  );
}

export default Home;